import {YStack, SelectButton} from "@chayka/ui";
import {useEffect, useLayoutEffect} from "react";
import {NIGHT_HOURS} from "@chayka/utils";

type HoursButtonsProps = {
  schedule: {hour: number; available: boolean}[];
  selectedHours: number[];
  setHours: (hours: number[]) => void;
  nightHoursTogether?: boolean;
};

export const HoursButtons: React.FC<HoursButtonsProps> = ({
  schedule,
  selectedHours,
  setHours,
  nightHoursTogether,
}) => {
  useEffect(() => {
    const availableHours = schedule.filter((s) => s.available).map((s) => s.hour);
    const newSelectedHours = selectedHours.filter((h) => availableHours.includes(h));
    if (newSelectedHours.length !== selectedHours.length) {
      setHours(newSelectedHours);
    }
  }, [schedule, selectedHours, setHours]);

  useLayoutEffect(() => {
    const firstSelectedHour = selectedHours[0];
    if (firstSelectedHour !== undefined) {
      const element = document.getElementById(`hour-button-${firstSelectedHour}`);
      if (element) {
        element.scrollIntoView({behavior: "smooth", block: "center"});
      }
    }
  }, [selectedHours]);

  const handleHourClick = (hour: number) => {
    if (nightHoursTogether && NIGHT_HOURS.includes(hour)) {
      const nightHours = NIGHT_HOURS.filter((h) =>
        schedule.some((s) => s.hour === h && s.available),
      );
      const areAllNightHoursSelected = nightHours.every((h) => selectedHours.includes(h));
      if (areAllNightHoursSelected) {
        setHours(selectedHours.filter((h) => !nightHours.includes(h)));
      } else {
        const newSelectedHours = Array.from(new Set([...selectedHours, ...nightHours]));
        setHours(newSelectedHours);
      }
      return;
    }

    if (selectedHours.includes(hour)) {
      setHours(selectedHours.filter((h) => h !== hour));
    } else {
      setHours([...selectedHours, hour]);
    }
  };

  return (
    <YStack className="gap-1">
      {schedule.map(({hour, available}) => (
        <SelectButton
          key={hour}
          disabled={!available}
          className="rounded-full! py-1!"
          selected={selectedHours.includes(hour)}
          onClick={() => handleHourClick(hour)}
          id={`hour-button-${hour}`}
        >
          <span className="text-sm font-bold">
            {hour} – {hour + 1 === 24 ? "00" : hour + 1}
          </span>
        </SelectButton>
      ))}
    </YStack>
  );
};
